import { render } from "./chatWindow.vue?vue&type=template&id=788b14b4"
import script from "./chatWindow.vue?vue&type=script&lang=js"
export * from "./chatWindow.vue?vue&type=script&lang=js"

import "./chatWindow.vue?vue&type=style&index=0&id=788b14b4&lang=scss"
script.render = render

export default script